import { render, staticRenderFns } from "./SelectedText.vue?vue&type=template&id=3ddbe89e&scoped=true"
import script from "./SelectedText.vue?vue&type=script&lang=js"
export * from "./SelectedText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddbe89e",
  null
  
)

export default component.exports